/*!
 * Copyright © 2019. Verizon Connect Ireland Limited. All rights reserved.
 */
import { Component, ChangeDetectionStrategy, Input } from '@angular/core';

@Component({
  selector: 'fm-vehicle-identification-number',
  templateUrl: './vehicle-identification-number.component.html',
  styleUrls: ['./vehicle-identification-number.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class VehicleIdentificationNumberComponent {
  @Input()
  set vin(value: string) {
    const vinTrimmed = value.replace(/\s/g, '').toUpperCase();
    this.leftVin = vinTrimmed.substr(0, vinTrimmed.length - 8);
    this.rightVin = vinTrimmed.substr(vinTrimmed.length - 8, 8);
  }

  leftVin: string;
  rightVin: string;
}
